import VisionMission2 from "./VisionMission2";
import FadeInOnScroll from "./FadeInOnScroll"; // 名字随便，但首字母要大写
import SlideInOnScroll from "./SlideInOnScroll";

export default function AboutUs() {
  return (
    <>
      {/* ===== Section 1：About Us 标题 + 视频背景 ===== */}
      <section className="relative overflow-hidden text-white">
        {/* 背景视频（只作用这一块） */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src="/aboutus-video.mp4" // 👈 换成你的实际视频路径
          autoPlay
          muted
          loop
          playsInline
        />

        {/* 遮罩层：压暗一点，文字更清楚 */}
        <div className="absolute inset-0 bg-black/60" />

        {/* 内容层 */}
        <div className="relative z-10 flex flex-col items-center justify-center px-4 py-16 md:py-36 text-center">
          <FadeInOnScroll>
            {/* <h1 className="text-3xl md:text-5xl font-extrabold leading-tight mb-4">
              About Us
            </h1>
            <p className="max-w-2xl text-sm md:text-base text-gray-200">
              Learn more about who we are, what we do, and how <br />
              we empower the next generation of AI-driven innovation.
            </p> */}
          </FadeInOnScroll>
          <FadeInOnScroll>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-2 text-gray-200 tracking-tight">
              ABOUT US
            </h2>
            <p className="text-gray-200 text-lg font-medium">
              Learn more about who we are, what we do, and how <br />
              we empower the next generation of AI-driven innovation.
            </p>
          </FadeInOnScroll>
        </div>
      </section>

      {/* ===== Section 2：三段文字介绍（独立一块） ===== */}
      <section className="bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44]">
        <SlideInOnScroll from="left">
          <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-[0_8px_30px_rgba(138,79,255,0.15)] p-6 md:p-12 space-y-8 md:space-y-10 border border-white/40">
              {[
                {
                  text: (
                    <>
                      <strong className="text-[#6a2dd9]">AI NOVA</strong> is a
                      trusted technology partner focused on driving digital
                      transformation through intelligent, scalable, and
                      future-ready solutions. Our commitment to innovation and
                      strategic excellence ensures that every solution we
                      deliver creates measurable, long-term value for our
                      clients.
                    </>
                  ),
                },
                {
                  text: (
                    <>
                      Our strength lies in our deep GPU expertise, advanced
                      network computing platforms, and low-latency networking
                      capabilities — enabling us to deliver high-performance
                      computing systems tailored to the evolving needs of modern
                      enterprises. We design and implement solutions that
                      accelerate AI workloads, power big data analytics, and
                      support complex simulations and real-time processing with
                      unmatched efficiency.
                    </>
                  ),
                },
                {
                  text: (
                    <>
                      By combining technical excellence with a client-focused
                      approach, we ensure every deployment is precisely aligned
                      with organizational goals, enhancing scalability,
                      optimizing performance, and driving measurable business
                      outcomes. Our ability to adapt technology to each client’s
                      environment has made{" "}
                      <strong className="text-[#6a2dd9]">AI NOVA</strong> a
                      trusted partner for enterprises seeking reliable,
                      future-ready computing infrastructure.
                    </>
                  ),
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-start gap-4 md:gap-5"
                >
                  <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-[#a076f9] to-[#7b5cff] text-white flex items-center justify-center shadow-[0_8px_20px_rgba(138,79,255,0.25)] mx-auto sm:mx-0">
                    ✓
                  </div>
                  <p className="text-[#2e165b]/90 leading-relaxed text-[0.95rem] md:text-[1.05rem] text-center sm:text-left">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </SlideInOnScroll>
      </section>
      <VisionMission2 />
    </>
  );
}
